import HeroAbout from "@/components/common/HeroAbout";
import Container from "@/components/layout/Container";

const visionValues = [
  {
    title: "양방향 대화",
    description: (
      <>
        소셜 미디어 시대의 비즈니스는 일방적인 정보 전달을 넘어 고객과 실시간으로 공감하며 단단한
        정서적 유대감을 쌓는 것에서 시작되어야 합니다.
        <br />
        <br />
        단순한 실행 도구를 제공하는 것을 넘어, 투명하고 정직한 양방향 대화의 기술로 비즈니스의
        진정한 가치를 연결하고 고객의 목소리와 함께 성장하는 내일을 만들어갑니다.
      </>
    ),
    image: "/img/about/value/about_values_01.png",
    reverse: false,
  },
  {
    title: "옴니채널 활용",
    description: (
      <>
        현대 비즈니스의 성패는 파편화된 다채널 환경 속에서도 끊김 없는 고객 경험을 제공하는
        옴니채널의 성공적인 활용에 달려 있습니다.
        <br />
        <br />
        우리는 단순히 여러 채널을 운영하는 것을 넘어, 모든 접점에서 발생하는 데이터를 하나로
        통합하여 고객 중심의 정교한 의사결정을 지원하는 지능형 대화 서비스를 지향합니다.
      </>
    ),
    image: "/img/about/value/about_values_02.png",
    reverse: true,
  },
  {
    title: "크로스 채널 분석",
    description: (
      <>
        파편화된 채널의 경계를 넘어 고객의 행동 데이터를 입체적으로 파악하는 크로스 채널 분석은 현대
        비즈니스의 핵심적인 경쟁력입니다.
        <br />
        <br />
        우리는 단순히 데이터를 쌓아두는 것에 그치지 않고, 복합적인 고객 여정을 정밀하게 분석하여
        가치 있는 통찰력을 도출하고 이를 즉각적인 개인화 실행으로 전환하는 최적의 분석 도구를
        지향합니다.
      </>
    ),
    image: "/img/about/value/about_values_03.png",
    reverse: false,
  },
];

const AboutVision = () => {
  return (
    <Container>
      <HeroAbout />

      <div>
        {/* 상단 메인 문구 */}
        <div className="text-center pt-10 pb-20 px-[2rem]">
          <h2 className="text-[2.4rem] font-medium text-[#333] leading-tight">
            비즈니스와 고객, <br />그 모든 접점을 잇는{" "}
            <strong className="relative inline-block text-black font-bold">
              <span className="relative z-10">최고의 연결 중심지</span>
              <span className="absolute bottom-[0.2em] left-0 h-[0.4em] bg-[#ffec83] animate-highlight"></span>
            </strong>
            로 도약하겠습니다.
          </h2>
        </div>

        <section className="flex flex-col gap-[7rem] px-[2rem] wide:px-0">
          {visionValues.map((item, idx) => (
            <div
              key={idx}
              className={`flex flex-col ${item.reverse ? "md:flex-row-reverse" : "md:flex-row"} items-stretch gap-[40px] md:gap-[40px]`}
            >
              {/* 이미지 영역*/}
              <div className="w-full md:w-1/2 flex items-center">
                <img src={item.image} alt={item.title} className="w-full h-[30rem] object-cover" />
              </div>

              {/* 텍스트 영역*/}
              <div className="w-full md:w-1/2 flex flex-col justify-start">
                <div className="w-full border-t-[1.5px] border-[#2A2A2F] mb-12"></div>

                <h3 className="text-[2.8rem] md:text-[3.2rem] font-bold text-[#2A2A2F] mb-10 tracking-tight">
                  {item.title}
                </h3>

                <p className="text-[1.8rem] md:text-[1.8rem] text-[#636776] leading-[1.4] break-keep font-regular">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </section>

        {/* 하단 CTA */}
        <section className="text-center mt-24 px-[2rem]">
          <p className="text-[1.8rem] text-500 mb-10 font-medium">
            스탠다드 네트웍스의 비전과 솔루션을 자세히 알고 싶으시다면,
          </p>
          <a
            href="/file/std_company_info.pdf"
            className="inline-block px-[6rem] py-5 border border-[#ccc] rounded-full text-[2rem] font-bold bg-white text-[#333] transition-all hover:bg-std-blue hover:text-white"
            download
          >
            회사 소개서 다운받기
          </a>
        </section>
      </div>
    </Container>
  );
};

export default AboutVision;
